import moment from "moment";
import { useMemo } from "react";

interface IDisplayDateProps {
  date?: string;
}

const DisplayDate = ({ date }: IDisplayDateProps) => {
  const value = useMemo(() => {
    if (date === undefined || date === null) return "";
    
    const formattedDate = new Intl.DateTimeFormat("it-IT", {
      timeZone: "Europe/Rome",
    }).format(moment.utc(date).toDate());

    return formattedDate;
  }, [date]);

  return <>{value}</>;
};

export default DisplayDate;
